import { mergeAttributes, Node } from '@tiptap/core';

import { createSuggestionPlugin } from '../plugins/suggestion/create-suggestion-plugin';
import { TagOptions } from '../plugins/suggestion/types';

export const Tag = Node.create<TagOptions>({
	name: 'tag',
	group: 'inline',
	inline: true,
	selectable: false,
	atom: true,

	addOptions() {
		return {
			allowanceBoostId: undefined,
			allowMultiple: true,
			budget: undefined,
			char: '@',
			component: () => null,
			debounceFetch: false,
			fetchData: () => [],
			insertOnClose: true,
			insertPrefixSpace: false,
			matchQuery: /.*/,
			matchWithoutTrigger: false,
			requireSelection: false,
			tagName: undefined,
			transformContent: undefined,
			uniqueId: '',
		};
	},

	addAttributes() {
		return {
			id: {
				default: null,
				parseHTML: (element) => element.getAttribute('data-id'),
				renderHTML: (attributes) => {
					if (!attributes.id) {
						return {};
					}

					return {
						'data-id': attributes.id,
					};
				},
			},

			record: {
				default: null,
				parseHTML: (element) => {
					const attr = element.getAttribute('data-record');

					if (attr) {
						return JSON.parse(attr);
					}

					return null;
				},
				renderHTML: (attributes) => {
					if (!attributes.record) {
						return {};
					}

					return {
						'data-record': JSON.stringify(attributes.record),
					};
				},
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: `span[data-type="${this.options.tagName ?? this.name}"]`,
			},
		];
	},

	renderHTML({ node, HTMLAttributes }) {
		return ['span', mergeAttributes({ 'data-type': this.options.tagName ?? this.name }, HTMLAttributes), `${this.options.char}${node.attrs.id}`];
	},

	renderText({ node }) {
		return `${this.options.char}${node.attrs.id}`;
	},

	addKeyboardShortcuts() {
		return {
			Backspace: () =>
				this.editor.commands.command(({ tr, state }) => {
					let isTag = false;
					const { selection } = state;
					const { empty, anchor } = selection;

					if (!empty) {
						return false;
					}

					state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
						if (node.type.name === (this.options.tagName ?? this.name)) {
							isTag = true;
							tr.insertText(this.options.char || '', pos, pos + node.nodeSize);

							return false;
						}
					});

					return isTag;
				}),
		};
	},

	addProseMirrorPlugins() {
		return [
			createSuggestionPlugin({
				editor: this.editor,
				name: this.name,
				...this.options,
			}),
		];
	},
});
